module.exports = __webpack_public_path__ + "img/it_iron_2019_all.079ce6dc.jpg";